import { render, staticRenderFns } from "./WQtypeCheckboxView.vue?vue&type=template&id=553c2465&"
import script from "./WQtypeCheckboxView.vue?vue&type=script&lang=ts&"
export * from "./WQtypeCheckboxView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports